var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var PacemPolygonElement_1;
import { CustomElement, Watch, PropertyConverters, P, Utils } from '@pacem/pacem-core';
import { ShapeElement } from './types';
import { TAG_MIDDLE_NAME } from './constants';
import { Shape } from './drawing';
//namespace Pacem.Components.Drawing {
let PacemPolygonElement = PacemPolygonElement_1 = class PacemPolygonElement extends ShapeElement {
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        if (!first) {
            switch (name) {
                case 'radius':
                case 'starIndent':
                case 'sides':
                    this.recomputeShape();
                    break;
            }
        }
    }
    getPathData() {
        const sides = this.sides, radius = this.radius, center = this.center;
        if (!Utils.isNull(sides) && !Utils.isNull(radius)) {
            return PacemPolygonElement_1.getPathData(center, radius, sides, this.starIndent);
        }
        return null;
    }
    getShapeGeometry() {
        const c = this.center ?? { x: 0, y: 0 }, r = this.radius ?? 0, sides = this.sides ?? 3, si = this.starIndent;
        if (sides < 3) {
            return Shape.empty();
        }
        return PacemPolygonElement_1.getShapeGeometry(c, r, sides, si);
    }
    static getShapeGeometry(center, radius, sides, starIndent = .0) {
        const p0 = { x: center.x, y: center.y - radius };
        let retval = `M ${p0.x} ${(p0.y)}`;
        const vertices = [p0];
        const theta = 2 * Math.PI / sides, theta2 = .5 * theta, isStar = starIndent > 0, apothem = radius * Math.cos(theta2);
        for (let j = 1; j < sides; j++) {
            const angle = j * theta, x = center.x + Math.sin(angle) * radius, y = center.y - Math.cos(angle) * radius;
            if (isStar) {
                const innerRadius = apothem * (1.0 - starIndent);
                const angle2 = angle - theta2, x1 = center.x + Math.sin(angle2) * innerRadius, y1 = center.y - Math.cos(angle2) * innerRadius;
                retval += ` L ${x1} ${y1} L ${x} ${y}`;
                vertices.push({ x: x1, y: y1 });
            }
            else {
                retval += ` L ${x} ${y}`;
            }
            vertices.push({ x, y });
        }
        if (isStar) {
            const innerRadius = apothem * (1.0 - starIndent);
            const angle2 = 2 * Math.PI - theta2, x1 = center.x + Math.sin(angle2) * innerRadius, y1 = center.y - Math.cos(angle2) * innerRadius;
            retval += ` L ${x1} ${y1}`;
            vertices.push({ x: x1, y: y1 });
        }
        vertices.push(p0);
        const width = radius * 2;
        return {
            pathData: retval + ' Z', vertices, boundingRect: { x: p0.x - radius, y: p0.y, width, height: width }
        };
    }
    static getPathData(center, radius, sides, starIndent = .0) {
        const { pathData } = PacemPolygonElement_1.getShapeGeometry(center, radius, sides, starIndent);
        return pathData;
    }
};
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Number })
], PacemPolygonElement.prototype, "sides", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Number })
], PacemPolygonElement.prototype, "radius", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Point })
], PacemPolygonElement.prototype, "center", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Number })
], PacemPolygonElement.prototype, "starIndent", void 0);
PacemPolygonElement = PacemPolygonElement_1 = __decorate([
    CustomElement({ tagName: P + '-' + TAG_MIDDLE_NAME + '-polygon' })
], PacemPolygonElement);
export { PacemPolygonElement };
